import { http } from './HttpService.js'

export default {
	load(params = '') {
		return http.get('produtos' + params)
	},
	loadCadastro(params = '') {
		return http.get('produto' + params)
	},
	ajuste(data, estoque, value){

		let update_estoque = '';
		let params = data.codigo
		
		update_estoque = estoque + Number(value);
		
		data.estoque_atual = update_estoque;
			
		return http.post('produtos/' + params, data)
	},
	update(data) {
		let params = data.codigo
		return http.post('produtos/' + params, data)
	},
	create(data) {
		return http.post('produtos/create', data)
	},
	destroy(codigo) {
		return http.get('produtos/destroy/'+codigo)
	},
	loadAll(params = '') {
		return http.get('produtosTodos' + params)
	},
	alteraEstoque(data) {
		let params = data.codigo
		return http.post('produtos/estoque/' + params, data)
	},
	historico(id, params = '') {
		return http.get(`produtos/${id}/historico${params}`)
	}
}